import { Exhibitor } from '@planone/bau365/util-fair-data';

import { staticExhibitors } from './data-access-exhibitor.static.mocks';
import {
  addressMock,
  contactMock,
  describedImageMock,
  productGroupMock,
  professionMock,
  topicMock,
  videoMock,
} from './generic.mocks';

export const exhibitorMock: Exhibitor = {
  display_name: '',
  id: '1',
  fair_id: 'bau23',
  name: 'Ihr Unternehmen',
  description:
    'In diesem Feld haben Sie die Chance, ihr Unternehmen ausführlich zu beschreiben. Es bietet genügend Platz um die gesamte Erfolgsgeschichte ihres Unternehmens erzählen. Vom Beginn bis zum heutigen Tag. Erklären Sie ihr Sortiment indem Sie auf ihre Produkte eingehen, wo diese herkommen und produziert werden. Seit wann existiert Ihr Unternehmen und wie hat es sich seitdem entwickelt? Was ist ihr Anspruch gegenüber Ihren Kunden? Welche Motivation und Philosophie möchten Sie nach außen tragen? Gehen Sie auch auf Ihre Mitarbeiter und Standorte ein. Beschreiben Sie, was auch immer sie möchten um einen ausführlichen, ersten Eindruck über Ihr Unternehmen zu hinterlassen und Aufmerksamkeit zu erzeugen: - - - Beispiel Text - - - Mit 30 Jahren Erfahrung und weltweit 2.000 Mitarbeitern, arbeiten wir täglich daran, heute und in Zukunft Technologie- und Serviceführer der Branche zu sein. Um dieses Ziel zu verwirklichen, richten wir uns konsequent an den Bedürfnissen unserer Kunden aus. In allen Phasen des Prozesses. Von der initialen Idee über die Planung bis hin zur Umsetzung und Nutzung unserer Produkte weltweit. Unsere Produkte kommen weltweit millionenfach zum Einsatz und erfüllen höchste Ansprüche an Design, Komfort, Sicherheit und Energieeffizienz. Unsere jahrelange Erfahrung in diesem Bereich wirkt sich maßgeblich auf die Qualität unserer Produkte aus. Mit höchster Professionalität arbeiten wir stetig daran, optimale Produkte an unsere Kunden zu liefern und ihnen mit Kompetenz zur Seite zu stehen. Besuchen Sie unseren Stand und überzeugen Sie sich selbst von unseren Produkten.',
  address: addressMock,
  contact: contactMock,
  contact_persons: [
    {
      id: '1',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
      mobile: '',
      avatar: {
        description: '',
        resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
        provider: 'RAW',
      },
    },
    {
      id: '2',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
    },
    {
      id: '3',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
    },
    {
      id: '4',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
      mobile: '',
      avatar: {
        description: '',
        resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
        provider: 'RAW',
      },
    },
  ],
  homepage: 'https://my-exhibitor.com',
  social_media: {
    linked_in: 'https://my-exhibitor.com',
    xing: 'https://my-exhibitor.com',
    instagram: 'https://my-exhibitor.com',
    facebook: 'https://my-exhibitor.com',
  },
  logo: {
    description: '',
    resource: 'assets/mock-exhibitor-page/logo.webp',
    provider: 'RAW',
  },
  mood_image: {
    description: '',
    resource: 'assets/mock-exhibitor-page/moodbild.webp',
    provider: 'RAW',
  },
  gallery: [
    {
      resource: 'assets/mock-exhibitor-page/exhibitorGalleryIMG1.webp',
      provider: 'RAW',
      description: 'Test',
    },
    {
      resource: 'assets/mock-exhibitor-page/exhibitorGalleryIMG2.webp',
      provider: 'RAW',
      description: 'Test',
    },
    {
      resource: 'assets/mock-exhibitor-page/exhibitorGalleryIMG3.webp',
      provider: 'RAW',
      description: 'Test',
    },
    {
      resource: 'assets/mock-exhibitor-page/exhibitorGalleryIMG4.webp',
      provider: 'RAW',
      description: 'Test',
    },
    {
      resource: 'assets/mock-exhibitor-page/exhibitorGalleryIMG5.webp',
      provider: 'RAW',
      description: 'Test',
    },
  ],
  brands: [
    {
      name: 'My Brand',
      logo: {
        description: '',
        resource: 'assets/mock-exhibitor-page/brandYellow.webp',
        provider: 'RAW',
      },
    },
    {
      name: 'My Brand',
      logo: {
        description: '',
        resource: 'assets/mock-exhibitor-page/brandGreen.webp',
        provider: 'RAW',
      },
    },
    {
      name: 'My Brand',
      logo: {
        description: '',
        resource: 'assets/mock-exhibitor-page/brandBlue.webp',
        provider: 'RAW',
      },
    },
  ],
  downloads: [
    {
      name: 'Aluminium-Fenstersystemen',
      file_name: 'Aluminium-Fenstersystemen',
      size: '20,40',
      path: 'https://www.plan.one',
    },
    {
      name: 'Schüco Livlng Classic',
      file_name: 'Schüco Livlng Classic',
      size: '8,20',
      path: 'https://www.bau365.de',
    },
    {
      name: 'Rondo',
      file_name: 'Schüco Livlng Rondo',
      size: '4,80',
      path: 'https://www.bau365.de',
    },
  ],
  topics: [topicMock, topicMock],
  professions: [professionMock, professionMock],
  product_groups: [productGroupMock, productGroupMock],
  exhibition_halls: [
    {
      id: '123',
      name: '1',
      fair_id: 'asdf',
      booths: [
        {
          name: 'Test Booth',
          coordinates: '123',
          area: {
            width: 2,
            depth: 4,
            total: 6,
          },
        },
      ],
    },
  ],
};

export class ExhibitorMockGenerator {
  static elements = 30;
  static mockData = exhibitorMock;

  static getIds() {
    return [...Object.keys(staticExhibitors), ...Array(ExhibitorMockGenerator.elements).keys()];
  }

  static getList(fair_id: string | undefined) {
    return ExhibitorMockGenerator.getIds().map((id: number | string) =>
      ExhibitorMockGenerator.getObject(<string>(<unknown>id), fair_id)
    );
  }

  static getPaginatedList(fair_id: string | undefined) {
    return {
      cursors: {
        next: undefined,
        prev: undefined,
      },
      items: ExhibitorMockGenerator.getList(fair_id),
    };
  }

  static getObject(id: string, fair_id: string | undefined) {
    if (staticExhibitors[id]) {
      return <Exhibitor>staticExhibitors[id];
    }

    return <Exhibitor>{
      ...ExhibitorMockGenerator.mockData,
      id: <string>(<unknown>id),
      fair_id: fair_id ?? 'bau23',
      name: ExhibitorMockGenerator.mockData.name + ' ' + <string>(<unknown>id),
      gallery: [
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
      ],
      mood_image: describedImageMock(),
      logo: describedImageMock(),
      videos: [videoMock, videoMock, videoMock, videoMock, videoMock, videoMock, videoMock],
      brands:
        ExhibitorMockGenerator.mockData.brands?.map((brand) => {
          return {
            ...brand,
            logo: describedImageMock(),
          };
        }) ?? [],
      contact_persons:
        ExhibitorMockGenerator.mockData.contact_persons?.map((contact) => {
          return {
            ...contact,
            avatar: describedImageMock(),
            description:
              'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet,',
            social_media: {
              linked_in: 'https://plan.one',
              xing: 'https://plan.one',
              instagram: 'https://plan.one',
              facebook: 'https://plan.one',
              twitter: 'https://plan.one',
              youtube: 'https://plan.one',
              pinterest: 'https://plan.one',
              tiktok: 'https://plan.one',
            },
            title: 'Prof. Dr.',
            first_name: 'Max',
            name: 'Mustermann',
            phone: '00000 0000000',
            mobile: '00000 0000000',
            fax: '00000 0000000',
            email: 'max@mustermann.de',
            website: 'https://plan.one',
          };
        }) ?? [],
    };
  }
}
